import {Component, computed, inject, OnInit} from '@angular/core';
import {LinkComponent} from '../../../../shared/components/link/link.component';
import {IconsComponent} from '../../../../shared/components/icons/icons.component';
import {TourService} from '../../../../shared/tour/tour.service';
import {AccessService} from '../../../../shared/services/access.service';

@Component({
  selector: 'app-lookup-header',
  imports: [
    LinkComponent,
    IconsComponent,
  ],
  templateUrl: './lookup-header.component.html',
  styleUrl: './lookup-header.component.css',
})
export class LookupHeaderComponent implements OnInit {
  tourService = inject(TourService);
  access = inject(AccessService);

  readonly settingsVisible = computed(() => this.access.has('edit_settings'));
  readonly settingsDisabled = computed(() => this.access.cannot('edit_settings'));

  ngOnInit() {
    this.registerTour();
  }

  private registerTour() {
    this.tourService.register('lookup', [
      {
        attachTo: {element: '#lookup-tab-vehicle'},
        title: 'Search by Vehicle',
        text: 'Select the vehicle\'s year, make, model, and fitment to find tires that match their vehicle',
        beforeShowPromise: () => new Promise(resolve => {
          document.querySelector<HTMLElement>('#lookup-tab-vehicle')?.click();
          setTimeout(() => { resolve(); }, 50); }
        ),
      },
      {
        attachTo: {element: '#lookup-alternate-fitments'},
        title: 'Alternate Fitments',
        text: 'View tires in similar sizes that also fit your vehicle',
      },
      {
        attachTo: {element: '#lookup-tab-size'},
        title: 'Search by Size',
        text: 'Search by the exact tire size instead of looking up by vehicle',
      },
      {
        attachTo: {element: '#lookup-tab-manual'},
        title: 'Manual Search',
        text: 'Enter a raw size or item number to search directly',
      },
      {
        attachTo: {element: '#lookup-settings-cog'},
        title: 'Settings',
        text: 'Adjust your preferences here — including which search tab opens by default',
        canShow: () => this.access.has('edit_settings'),
      },
      {
        title: 'You\'re All Set!',
        text: 'That\'s the lookup page — pick a search method and find your customer\'s tires',
        arrow: false,
      },
    ]);
  }
}
